import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent, Stack, alpha } from '@mui/material';

const Services = () => {
  const serviceItems = [
    {
      title: 'AI Solutions',
      description:
        'We design assistants, classifiers, and automation workflows that integrate directly with your internal tools and external APIs, turning AI into a dependable part of day-to-day operations.',
    },
    {
      title: 'Web Development',
      description:
        'From landing pages to API-connected platforms, we build responsive web experiences that stay fast, scalable, and easy to evolve as your product and team mature.',
    },
    {
      title: 'Cloud Services',
      description:
        'We provision secure hosting, storage, and deployment pipelines with cost visibility built in, so you can scale confidently without losing control of reliability or spend.',
    },
  ];

  return (
    <Box
      id="services"
      sx={{
        py: { xs: 6, md: 9 },
      }}
    >
      <Container maxWidth="lg">
        <Stack spacing={1.5} sx={{ mb: { xs: 3, md: 5 }, maxWidth: 720 }}>
          <Typography
            variant="overline"
            sx={{ color: 'secondary.main', letterSpacing: '0.16em', fontWeight: 700 }}
          >
            Services
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: { xs: '2rem', sm: '2.6rem', md: '3.2rem' },
              color: 'primary.main',
            }}
          >
            Structured delivery for ambitious digital projects.
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: 'text.secondary', fontSize: { xs: '1rem', md: '1.08rem' } }}
          >
            We combine engineering clarity with modern tooling, giving your business a partner that
            can move quickly without sacrificing maintainability.
          </Typography>
        </Stack>

        <Grid container spacing={{ xs: 2.5, md: 3 }}>
          {serviceItems.map((service, index) => (
            <Grid item xs={12} md={4} key={service.title}>
              <Card
                elevation={0}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  overflow: 'hidden',
                  backgroundColor: '#ffffff',
                  border: '1px solid rgba(16, 35, 63, 0.08)',
                  boxShadow: '0 22px 45px rgba(16, 35, 63, 0.08)',
                  transition: 'all 0.35s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 28px 60px rgba(16, 35, 63, 0.12)',
                  },
                }}
              >
                <Box
                  sx={{
                    px: 3,
                    pt: 3,
                  }}
                >
                  <Box
                    sx={{
                      width: 54,
                      height: 54,
                      borderRadius: 3,
                      mb: 2,
                      backgroundColor: alpha('#20c6b7', 0.12),
                      color: 'secondary.main',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 800,
                      fontSize: '1.1rem',
                    }}
                  >
                    0{index + 1}
                  </Box>
                  <Typography
                    variant="h5"
                    component="h3"
                    sx={{
                      fontWeight: 800,
                      color: 'primary.main',
                      fontSize: { xs: '1.25rem', md: '1.4rem' },
                    }}
                  >
                    {service.title}
                  </Typography>
                </Box>
                <CardContent
                  sx={{
                    flexGrow: 1,
                    px: 3,
                    pb: 3.25,
                    pt: 1.25,
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      color: 'text.secondary',
                      fontSize: { xs: '0.96rem', md: '1rem' },
                    }}
                  >
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;
